import { useWizardState } from './WizardState';

export function Root({
  testId,
  children,
}: {
  testId?: string;
  children: React.ReactNode;
}) {
  const wizardState = useWizardState();

  // Wizards with dynamic steps can unmount in a way that causes the current step to be undefined
  // This is a workaround to prevent the wizard from crashing.
  if (!wizardState.currentStep) {
    return null;
  }

  return <div data-testid={testId}>{children}</div>;
}
